function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_239",
  "data-name": "Group 239",
  transform: "translate(-1591 -62)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_25",
  "data-name": "Ellipse 25",
  transform: "translate(1599 70)",
  fill: "none",
  stroke: "#111",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_235",
  "data-name": "Group 235"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114",
  "data-name": "Rectangle 114",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1612 74)",
  fill: "#111"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_115",
  "data-name": "Rectangle 115",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1591 74)",
  fill: "#111"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_238",
  "data-name": "Group 238",
  transform: "translate(522.834 -1112.232) rotate(45)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114-2",
  "data-name": "Rectangle 114",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1612 74)",
  fill: "#111"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_115-2",
  "data-name": "Rectangle 115",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1591 74)",
  fill: "#111"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  transform: "translate(1529 1679) rotate(-90)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114-3",
  "data-name": "Rectangle 114",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1612 74)",
  fill: "#111"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_115-3",
  "data-name": "Rectangle 115",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1591 74)",
  fill: "#111"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237",
  transform: "translate(416.768 1156.166) rotate(-45)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114-4",
  "data-name": "Rectangle 114",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1612 74)",
  fill: "#111"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_115-4",
  "data-name": "Rectangle 115",
  width: 5,
  height: 2,
  rx: 1,
  transform: "translate(1591 74)",
  fill: "#111"
})));

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.395b4d4c.svg";
export { ForwardRef as ReactComponent };